import { defineComponent as _defineComponent } from 'vue'
import { showToolbox } from '@/store'
import Dataset from './dataset/index.vue'
import Reposition from './reposition/index.vue'
import { useViewEdit } from '@/hook/useEdit'
import { onActivated, ref } from 'vue'
import { ui18n } from '@/lang'
import { sceneSource } from '@/store/setup'
import router from '@/router'
import { params } from '@/hook'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const options = [{ label: ui18n.t('dataset.title'), comp: Dataset }]
if (sceneSource.value === '7') {
  // options.push({ label: ui18n.t('scene.pano'), comp: Reposition })
}
const current = ref(options[0].label)
useViewEdit()
onActivated(() => {
  current.value = options[0].label

  if ((params as any).type === 'reposition' && options.length === 2) {
    current.value = options[1].label
    ;(params as any).type = undefined
    const url = new URL(location.href)
    url.searchParams.delete('type')
    history.replaceState(null, '', url.toString())
    //   location.hash = location.hash.substring(0, ndx);
  }
})

const __returned__ = { options, current, get showToolbox() { return showToolbox } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})